import { render, staticRenderFns } from "./storeOrderLogistics.vue?vue&type=template&id=c67c3284&scoped=true"
import script from "./storeOrderLogistics.vue?vue&type=script&lang=js"
export * from "./storeOrderLogistics.vue?vue&type=script&lang=js"
import style0 from "./storeOrderLogistics.vue?vue&type=style&index=0&id=c67c3284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67c3284",
  null
  
)

export default component.exports